import DPTable, { LabelProps } from "Components/DP/DPTable/DPTable";
import UserPaymentRow from "Components/Pages/UserProfile/UserPayments/UserPaymentRow/UserPaymentRow";
import Box from "@material-ui/core/Box";
import React, { FC, useState, useEffect } from "react";
import { DPEmployeePayment } from "Shared/types/Payments";
import { Typography } from "@material-ui/core";
import { DPEmptyTable } from "Components/DP";
import isEqual from "lodash/isEqual";

const toUserColumnNames: (string | LabelProps)[] = [
  "Sent",
  "Type",
  { label: "Account", align: "right" },
  { label: "Amount", align: "right" },
  { label: "Method", align: "right" },
  { label: "Fees", align: "right" },
  { label: "Notes", align: "center" },
];

type Props = {
  payments: DPEmployeePayment[];
};

const UserPayments: FC<Props> = ({ payments }) => {
  const [userPayments, setUserPayments] = useState<DPEmployeePayment[]>([]);

  useEffect(() => {
    if (!isEqual(payments, userPayments)) {
      setUserPayments(payments);
    }
  }, [payments, userPayments]);

  return (
    <Box id="payments-to-user">
      <Typography variant="h3">Payments From DailyPay to User</Typography>

      <DPTable headers={toUserColumnNames}>
        {userPayments.length ? (
          userPayments.map(
            ({
              id,
              payPeriodAmountCents,
              processedOn,
              paymentType,
              receivingAccount,
              feeAmountCents,
              paymentMethod,
              relatedPayments,
            }) => (
              <UserPaymentRow
                id={id}
                key={id}
                payPeriodAmountCents={payPeriodAmountCents}
                processedOn={processedOn}
                paymentType={paymentType}
                receivingAccount={receivingAccount}
                feeAmountCents={feeAmountCents}
                paymentMethod={paymentMethod}
                relatedPayments={relatedPayments}
              />
            )
          )
        ) : (
          <DPEmptyTable message="Detailed activity will appear when the user makes a transfer or DailyPay sends the user’s paycheck." />
        )}
      </DPTable>
    </Box>
  );
};

export default UserPayments;
